/* eslint-disable no-extend-native */
Number.prototype.fixRounding = function () {
  return (this.toFixed(2)).replace(/\.00$/, '');
};
